<template>
  <div >
    <div  v-if="gate_pass || gate_pass != null" class="md-layout">
      
      <md-toolbar class="md-dense md-info noprint">
        <h3 style="flex:1;" class="md-title"></h3>
        <md-button style="float: right; " class="noprint md-dense md-info md-icon-button" @click="printPage()" ><md-icon>print</md-icon></md-button>
        <md-menu md-direction="bottom-start" style="margin-right:20px;">
          <md-button class="nonprint; md-info md-dense md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
            <md-menu-content>
            <md-menu-item v-if="role.update" @click="editBizdevInvoice(gate_pass.id)">Edit</md-menu-item>
            <md-menu-item v-if="role.delete"  @click="deleteConfirmation(gate_pass.id)">Delete</md-menu-item>
            <md-menu-item @click="backToList">Back to Invoice list</md-menu-item>
          </md-menu-content>
        </md-menu>
      </md-toolbar>
      <md-content>
            <table style="width:100%; table-layout: fixed;" >
              <tr>
              <td style="width:20%;"  rowspan="4"><img src="@/pages/Dashboard/Workshop/GatePass/Component/lambang_gms.jpg" style="width:100%;"></td>
              <td style="text-align:center; font-size: 4mm; font-weight:bold;">PT Charged Tech Indonesia INDONESIA</td>
            </tr>
            <tr>
              <td style="text-align:center; font-size: 2.5mm; font-weight: 400;">Sona Topas Tower, Lantai 12A</td>
            </tr>
            <tr>
              <td style="text-align:center; font-size: 2.5mm; font-weight: 400;">Jalan Jend. Sudirman, No. 26 RT.4/RW.2 Kuningan, Karet Setia Budi, Jakarta Selatan, Daerah Khusus Ibukota Jakarta. 12920.</td>
            </tr>
            <tr>
              <td style="text-align:center; font-size: 2.5mm; font-weight: 400;"><span style="color:blue">https://www.global-mobility-service.com/en/</span> | Email : <span style="color:blue">idn_info@global-mobility-service.com</span>  | Phone : (+6221) 7391-0333</td>
            </tr>
          </table>
<hr>
          <table style="width:100%; table-layout: fixed; margin-top:20px;" >
            <tr>
              <td style="text-align:center; font-size: 5mm; font-weight:900; text-decoration:underline;">GATE PASS</td>
            </tr>
            <tr>
              <td style="text-align:center; font-size: 4.5mm;">Nomor : {{ gate_pass.gate_pass_no }}</td>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed; margin-top:20px;" >
            <tr>
              <td>Yang bertanda tangan dibawah ini:</td>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed; margin-top:20px; margin-left:" >
            <colgroup>
                    <col style="width: 46mm">
                    <col style="width: 5mm">
                    <col style="width: 129mm; ">
            </colgroup>
            <tr>
              <td style="text-indent: 50px;">Nama</td>
              <td style="text-indent: 50px;">:</td>
              <td style="text-indent: 50px;">Syarifah Aliyah</td>
            </tr>
            <tr>
              <td style="text-indent: 50px;">Perusahaan</td>
              <td style="text-indent: 50px;">:</td>
              <td style="text-indent: 50px; text-align:left;">On Behalf PT Charged Tech Indonesia</td>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed; margin-top:20px;" >
            <tr>
              <td>Menerangkan bahwa kendaraan {{ gate_pass.gate_pass_vehicle.vehicle_types.vehicle_brands.vehicle_brand_name+" "+gate_pass.gate_pass_vehicle.vehicle_types.vehicle_model }} : </td>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed; margin-top:20px; margin-left:" >
            <colgroup>
                    <col style="width: 46mm">
                    <col style="width: 5mm">
                    <col style="width: 129mm; ">
            </colgroup>
            <tr>
              <td style="text-indent: 50px;">No Polisi</td>
              <td style="text-indent: 50px;">:</td>
              <td style="text-indent: 50px;">{{ gate_pass.gate_pass_vehicle.vehicle_plate_no}}</td>
            </tr>
            <tr>
              <td style="text-indent: 50px;">No Rangka/Mesin</td>
              <td style="text-indent: 50px;">:</td>
              <td style="text-indent: 50px; text-align:left;">{{ gate_pass.gate_pass_vehicle.vehicle_chassis_no+"/"+gate_pass.gate_pass_vehicle.vehicle_engine_no }}</td>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed; margin-top:20px; margin-left:" >
            
            <tr>
              <p style="text-indent: 50px;">Unit tersebut akan keluar dari pool NEXT Taksi Jl. Kranggan No. 26 Jatiraden Bekasi Jawa
                 Barat pada tanggal {{ gate_pass.gate_pass_start_date}}, untuk di serah terima kan kepada pengemudi a/n <span style="font-weight:bold;">{{ gate_pass.gate_pass_applicant_name }}</span> sebagai {{ gate_pass.gate_pass_purpose }}, Demikian surat keterangan ini dibuat dengan benar dan dapat dipergunakan sebagaimana mestinya.</p>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed; margin-top:20px; margin-left:" >
            <tr>
              <td>Bekasi, {{ gate_pass.gate_pass_start_date }}</td>
            </tr>
            <tr>
              <td>Prepared By</td>
              <td style="padding-left:40mm">Approved By</td>
            </tr>
          </table>

          <table style="width:100%; table-layout: fixed;  margin-top:100px;" >
            
            <tr>
              <td style="text-decoration:underline;">Syarifah Aliyah</td>
              <td style="text-decoration:underline; padding-left:40mm">Ade Fadillah</td>
            </tr>
            <tr>
              <td>On Behalf Operational GMS</td>
            </tr>
          </table>

            <!-- <table style="table-layout: fixed;  margin-top: 2px; width:100%; " >
              <tr>
                <td style="width:140mm; vertical-align:top;">

                    <table class="table-inside-td" style=" border-collapse: collapse; table-layout: fixed; margin-top: 3mm;" >
                    <colgroup>
                        <col style="width: 60mm;">
                        <col style="width: 60mm; ">
                    </colgroup>
                    <tr>
                        <td class="bold-title" style="padding-left:20mm; font-size:6.5mm;">INVOICE</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 35mm;">
                        <span style="font-size:4mm;">{{gate_pass.contract_detail.client.client_name}}</span>
                        </td>
                    </tr>
                    <tr>&zwnj;</tr>
                    <tr>&zwnj;</tr>
                    <tr>&zwnj;</tr>
                    <tr>&zwnj;</tr>

                    
                    </table>
                </td>
                <td style="width:60mm; vertical-align:top;">

                    <table class="table-inside-td" style=" border-collapse: collapse; table-layout: fixed; margin-top: 3mm;" >
                    <colgroup>
                        <col style="width: 20mm;">
                        <col style="width: 20mm; ">
                    </colgroup>
                    <tr>
                        <td class="bold-title">Invoice Date</td>
                    </tr>
                    <tr>
                        <td >
                        <span>{{gate_pass.invoice_date}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="bold-title">Invoice No.</td>
                    </tr>
                    <tr>
                        <td >
                        <span>{{no_invoice(gate_pass.invoice_date,gate_pass.invoice_no_sub,gate_pass.contract_detail.client.client_invoice_from)  }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="bold-title">Reference</td>
                    </tr>
                    <tr>
                        <td >
                        <span>{{$moment(gate_pass.invoice_period_from, "YYYY-MM-DD", true).format("MMMM YYYY")}}</span>
                        </td>
                    </tr>

                    
                    </table>
                </td>
              </tr>
            </table>

            <table style="border-collapse: width:100%; collapse; margin-top:10px; margin-bottom:20px;" >
            <thead>
              <tr>
                <th  style="width:10mm">No</th>
                <th colspan="2">Description</th>
                <th >Unit Price</th>
                <th >Amount IDR</th>     
              </tr>
              <tr>
                  <td style="border-bottom:1px solid black;" colspan="5"><span ></span></td>
              </tr>
            </thead>
              <tr v-for="(item, index)  in gate_pass"
                    :key="index">
                      <td style="text-align:center">{{  }}</td>
                      <td colspan="2" style="text-align:center">{{ }}</td>
                      <td style="text-align:center">{{ formatPrice(item.list_contract_vehicle_payment_amount)}}</td>
                      <td style="text-align:center"><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.list_contract_vehicle_payment_amount)}}</span>
                      </td>
               
              </tr>
              <tr>
                  <td style="border-bottom:1px solid black;" colspan="5"><span ></span></td>
              </tr>
              <tr >
                <td colspan="3"></td>
                <td style="text-align:center;"><b>Subtotal</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{ }}</span></td>
              </tr>
              <tr >
                <td colspan="3"></td>
                <td style="text-align:center;"><b>VAT</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{  }}</span></td>
              </tr>
               <tr>
                   <td colspan="3" ></td>
                  <td style="border-bottom:1px solid black;" colspan="2"><span ></span></td>
              </tr>
              <tr >
                <td colspan="3"></td>
                <td style="text-align:center;"><b>Total</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{ }}</span></td>
              </tr>
            </table>

            <table style="table-layout: fixed;  margin-top: 2px; width:100%; margin-top:30px;" >
              <tr>
                <td style="width:120mm; vertical-align:top;">

                    <table class="table-inside-td" style=" border-collapse: collapse; table-layout: fixed; margin-top: 3mm;" >
                    <colgroup>
                        <col style="width: 60mm;">
                        <col style="width: 60mm; ">
                    </colgroup>
                    <tr>&zwnj;</tr>
                    <tr>
                        <td ><span style="font-weight:bold">Due Date :</span> {{  }}</td>
                    </tr>
                    <tr>
                        <td >Payment Address :
                        </td>
                    </tr>
                    <tr><td>MITRA UNGGUL INDOTAMA PT.</td></tr>
                    <tr><td>BCA KCU SCBD</td></tr>
                    <tr><td>No. Acc 0068989739</td></tr>

                    
                    </table>
                </td>
                <td style="width:60mm; vertical-align:top;">

                    <table class="table-inside-td" style=" border-collapse: collapse; table-layout: fixed; margin-top: 3mm;" >
                    <tr>
                <td style="width:25%; "><img  src="@/pages/Dashboard/Bizdev/LogiInvoice/Component/ttd_mui.png" style="float:right; width:100%; margin-right:20px;  max-width:250px;"></td>
                
              </tr>

                    
                    </table>
                </td>
              </tr>
            </table>

             -->

            
          </md-content>
          <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
          <button class="noprint" @click="generateReport" >Print Invoice</button> -->
       
      </div>
    
    <div v-bind:style="{ display: not_found}">
      <center  v-if="gate_pass == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import angkaTerbilang from '@develoka/angka-terbilang-js';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

  // import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
  // import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
  // import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
  // import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
  // import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
  
  export default {
     name: "detail-gate_pass",

    // props: {
    //   service_estimate: Object,
    // },

    components: {
      // ValidationError,
      // FormWizard,
      // TabContent,
      // "info-card": InfoCard,
      // "client-card": ClientCard,
      // "vehicle-card": VehicleCard,
      // "service-card": ServiceCard,
      // "part-card": PartCard,
      
    }, 

    mixins: [formMixin],

    data: () => ({
      not_found: 'none',
      role:'',
      gate_pass : null,
    }),

    created() {
      this.getGatePassData();
    },

    methods: {
      //fungsi ambil data gate_pass dari api dengan id yang dikirim bersamaan melalui route
      async getGatePassData(){
        this.role =  await this.$store.getters["role_permission/route_filter"]
        await this.$store.dispatch("workshop_gate_pass/get", this.$route.params.id)
        this.gate_pass = await this.$store.getters["workshop_gate_pass/gate_pass"]

        //check apakah data dari api ada
        if(!this.gate_pass){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }
        
        console.log(await this.$store.getters["workshop_gate_pass/gate_pass"])
        
        
      },

      

      //fungsi untuk pindah ke page edit
      editBizdevInvoice(id) {
      this.$router.replace({ name: 'Edit Gate Pass', params: { id: id } })
      },
      //fungsi untuk kembali ke page list
      backtoList() {
      this.$router.replace({ name: 'List Gate Pass'})
      },
  //fungsi konfirmasi hapus
    // deleteConfirmation(id) {
    //   Swal.fire({
    //     title: 'Are you sure?',
    //     text: 'You wont be able to revert this!',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, delete it!',
    //     cancelButtonText: 'No, cancel!',
    //     buttonsStyling: true
    //     }).then((result) => {
    //       if (result.value){
    //         this.deletegate_pass(id)
    //       }
    //     });
    // },
    // //fungsi untuk menghapus
    // async deletegate_pass(id) {
    //    try {
    //      //kirim data yang akan dihapus ke api
    //       await this.$store.dispatch("gate_pass/destroy", id)
    //       //panggil alert sukses
    //       await this.$store.dispatch("alerts/success", "Invoice data delete successfully.")
    //       //kembali ke list
    //       this.$router.replace({ name: 'List Gate Pass'})
    //     } catch (e) {
    //       //panggil alert gagal
    //       await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
    //       //this.setApiValidation(e.response.data.errors)
    //     }
    // },

      //kembali kelist
      async backToList(){
          await this.$router.replace({name: 'List Gate Pass'})
      },
      //print screen mode
      printPage(){
        window.print()
        //window.open("http://localhost/github/erp-testing/laravel-json-api/public/api/v1/test/test");
        // let routeData = this.$router.resolve({name: 'Pdf Faktur'});
        // window.open(routeData.href, '_blank');
      }
      
    }
  };
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
margin: 4px;
}
.bold-title{
font-weight:bold;
}
.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}


@media print{
   .print{
       visibility: visible;
       margin: none;
   }
   .noprint{
     display: none;
   }

  
}

</style>